import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ReviewsSentSuccesModalWrapper = styled.div`
  position: relative;
  padding: 1.25rem;
  text-align: center;
`;

export const ReviewSentText = styled.div`
  ${theme.typography.titleLarge}
  margin-block: 0.5rem;
`;

export const ReviewSentThanksText = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
`;

export const DoneButton = styled(Button)`
  margin-top: 2rem;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    max-width: 250px;
  }
`;

export const InfoLine = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: ${theme.color.common.yellow95};
  gap: 8px;
  margin-top: 20px;

  svg {
    min-width: 1rem;
  }

  button {
    all: unset;
    cursor: pointer;
    color: ${theme.color.text.primary};
    text-decoration: underline;
    margin-left: auto;
    ${theme.typography.labelSmall}
    white-space: nowrap;
  }
`;
